<template>
    <router-link class="app-logo" :to="link.path" :alt="link.label">
        <img class="app-logo--img" :src="logoPath">
    </router-link>
</template>

<script>
    import staticPath from 'framework/filters/staticPath';

    const APP_LOGOS_DARK = {
        de: staticPath('img/logos/logo-de.svg'),
        fr: staticPath('img/logos/logo-fr.svg'),
        it: staticPath('img/logos/logo-it.svg'),
    };

    const APP_LOGOS_LIGHT = {
        de: staticPath('img/logos/logo-de-light.svg'),
        fr: staticPath('img/logos/logo-fr-light.svg'),
        it: staticPath('img/logos/logo-it-light.svg'),
    };

    export default {
        props: {
            theme: {
                type: String,
                default: 'dark',
            },
            /** @type {ILink} */
            link: {
                type: Object,
                required: true,
            },
        },
        computed: {
            logoPath() {
                const map = this.theme === 'dark' ? APP_LOGOS_DARK : APP_LOGOS_LIGHT;
                return map[globals.config.current_language];
            },
        },
    };
</script>
